import clsx from 'clsx'
import Layout from './Layout'
import Preloader from '../common/Preloader'
import BgSlash from '../common/BgSlash'
import TopHeader from '../TopHeader'
import PageDrawer from '../common/PageDrawer'
import Container from "./Container";
import { HelmetBlock } from '../common/atom/HelmetBlock'

export default function FullPageBase({title, top, item, children}) {
  let type = (item && item.type) || "";

  return <Layout type={type}>
        <HelmetBlock title={title}/>
    <Preloader show={!!top} />
    <Container>
      <BgSlash />
      <TopHeader />
      <div className={clsx("fullpage main", item && item.type)}>
        {children}
      </div>
      <PageDrawer />
    </Container>
    </Layout>
}
